/* src/stores/theme.js */
import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
  
    darkMode: localStorage.getItem('theme') !== 'light'
  }),
  actions: {

    toggleTheme() {
  
      this.darkMode = !this.darkMode
      this.applyTheme()
    },
    
    initTheme() {
  
      this.applyTheme()
    },
    
    applyTheme() {
  
      if (this.darkMode) {
  
        document.documentElement.classList.add('dark')
        localStorage.setItem('theme', 'dark')
      } 
      else {
      
        document.documentElement.classList.remove('dark')
        localStorage.setItem('theme', 'light')
      }
    }
  }
})